export default __webpack_public_path__ + "static/media/pharo.f7a6a3e7.png";